import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import LicenseGroup, { licenseOption } from "./LicenseGroup";

import formatDate from "../../../../../utils/formatDate";
import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import { useStore } from "../../../../../connect";

import strings from "../../../../../locales/strings";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const UnlimitedLicenses = () => {
  const { profile, baseUrl } = useStore();

  const billingLink = `https://billing.${baseUrl}/addinvoice?utm_source=header&utm_campaign=new_header&utm_content=header_addinvoice`;

  profile.payedServices.unlimited.list[0];

  if (
    profile.payedServices.unlimited.list.length > 1 &&
    profile.payedServices.unlimited.list[0].endDate ===
      profile.payedServices.unlimited.list[1].endDate
  ) {
    return (
      <LicenseGroup
        refreshDisabled={profile.refreshUnlimitedLicenses.disabled}
        refreshLoading={profile.refreshUnlimitedLicenses.loading}
        refreshError={profile.refreshUnlimitedLicenses.error}
        refreshAction={profile.refreshUnlimitedLicenses.refresh}
        href={billingLink}
        onClick={() => sendNavigationMetric("UNLIMITED_LICENSES")}
        after={
          <span
            className={cx(
              "payed-days",
              profile.payedServices.unlimited.list[0].remainingDays <= 10 &&
                "expired"
            )}
          >
            {strings.paidFor}&nbsp;
            {formatDate(profile.payedServices.unlimited.list[0].endDate)}(
            {profile.payedServices.unlimited.list[0].remainingDays}&nbsp;
            {strings.profile_days})
          </span>
        }
        option={licenseOption.ADD}
      >
        <span className={cx("licenses-list")}>
          {profile.payedServices.unlimited.list.map((license) => (
            <span key={license.serviceId}>{license.serviceName}</span>
          ))}
        </span>
      </LicenseGroup>
    );
  }

  return profile.payedServices.unlimited.list.map((license) => (
    <LicenseGroup
      key={license.serviceId}
      refreshDisabled={profile.refreshUnlimitedLicenses.disabled}
      refreshLoading={profile.refreshUnlimitedLicenses.loading}
      refreshError={profile.refreshUnlimitedLicenses.error}
      refreshAction={profile.refreshUnlimitedLicenses.refresh}
      href={billingLink}
      onClick={() => sendNavigationMetric("UNLIMITED_LICENSES")}
      after={
        <span
          className={cx("payed-days", license.remainingDays <= 10 && "expired")}
        >
          {strings.paidFor}&nbsp;
          {formatDate(license.endDate)}({license.remainingDays}
          &nbsp;
          {strings.profile_days})
        </span>
      }
      option={licenseOption.ADD}
    >
      {license.serviceName}
    </LicenseGroup>
  ));
};

export default observer(UnlimitedLicenses);
